module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_clubs-king.37f4c158.svg";